/* eslint-disable no-trailing-spaces */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
// import { ModalComponent } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
// PARA CONSUMIR MEIDANTE HTTP
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// import { SQLite } from '@awesome-cordova-plugins/sqlite/ngx';

// 🔹 Interceptor
import { AuthInterceptor } from './core/interceptors/auth.interceptor';

import { SwiperModule } from 'swiper/angular';

import { IonicStorageModule } from '@ionic/storage-angular';

// 🔹 AGREGAR ESTA LÍNEA - jeep-sqlite
import { defineCustomElements as jeepSqlite } from 'jeep-sqlite/loader';

// 🔹 LLAMAR ESTO ANTES DEL @NgModule
jeepSqlite(window);

@NgModule({ 
    declarations: [
        AppComponent
    ],
    // entryComponents: [],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        CommonModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        IonicStorageModule.forRoot(),
        SwiperModule, // ✅ Importar SwiperModule
    ], 
        
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // SQLite,
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ] 
})
export class AppModule {}